const defaultScheme = [
    '#E02B57',
    '#006BD6',
    '#FFB500',
    '#F6678D',
    '#3599FF',
    '#008061',
    '#15A84E',
    '#6B3D00',
    '#FF9200',
    '#9C082C',
    '#776DF9',
    '#BB7311',
    '#004C99',
    '#FFE5C2',
    '#FFD9E2'
];

export { defaultScheme };
//# sourceMappingURL=color-schemes.js.map
